import axios from 'axios';
import { exception as exception$1 } from '@kso/util';

/**
 * AXIOS的响应拦截器
 * 拦截接口的相应，统一处理接口异常的逻辑
 */
function DefaultMessage() {}
DefaultMessage.error = function () {};
DefaultMessage.close = function () {
  console.info('DefaultMessage close invoke');
};
var interceptor = function interceptor() {
  var Message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultMessage;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    name: 'exception',
    response: {
      fail: function fail(error) {
        /*
         * 使用axios的cancel取消
         * https://github.com/axios/axios/tree/master/lib/cancel
         */
        if (axios.isCancel(error) || typeof options.exclude === 'function' && options.exclude(error)) {
          return Promise.reject(error);
        }
        // 未知无message的错误
        if (!error.message) {
          Message.close && Message.close();
          error.silent = true; // 接口错误，静默处理
          return Promise.reject(error);
        }
        var response = error.response,
          message = error.message,
          status = error.status;
        var _message_;

        // 基准的解析response中的错误
        var parsedMessage = exception$1(error, options.addtion);

        // 网络异常
        if (error.code === 'ECONNABORTED') {
          response = {
            status: 504,
            data: 'Gateway Timeout',
            statusText: 'Gateway Timeout'
          };
        }
        if (message === 'Network Error') {
          _message_ = '操作失败，请检查你的网络';
        } else if (status >= 500) {
          _message_ = status === 504 && '服务器忙请稍后再试' || '服务器错误';
          error.silent = true; // 接口错误，静默处理
        }

        // 延迟调用错误的Messager
        var delayMessagerHander = setTimeout(function () {
          parsedMessage && Message.error(_message_ || parsedMessage);
        }, 200);
        try {
          Object.defineProperty(error, 'xResponse', {
            value: response || false,
            enumerable: true
          });
          Object.defineProperty(error, 'response', {
            get: function get() {
              clearTimeout(delayMessagerHander);
              return response;
            }
          });
        } catch (e) {
          console.warn('不支持Object的defineProperty属性');
        }
        return Promise.reject(error);
      }
    }
  };
};
function exception (Message, options) {
  this.$inject(interceptor(Message, options));
}

export { exception as default };
